function getPageStructureLoadError(error: any) {
  if (error?.response?.status !== 422) {
    return null;
  }

  const sectionsError = error?.response?.data?.errors?.sections;
  const repairPageId = getRepairPageId(error);
  const repairableSections = getRepairableSections(error);

  if (Array.isArray(sectionsError) && sectionsError.length > 0) {
    return {
      title: "Esta pagina es inconsistente con su schema y no puede editarse hasta corregir sus secciones",
      detail: sectionsError[0],
      canRepairMissingSections: canRepairMissingSections(sectionsError[0]),
      repairPageId,
      repairableSections,
    };
  }

  if (typeof sectionsError === "string" && sectionsError) {
    return {
      title: "Esta pagina es inconsistente con su schema y no puede editarse hasta corregir sus secciones",
      detail: sectionsError,
      canRepairMissingSections: canRepairMissingSections(sectionsError),
      repairPageId,
      repairableSections,
    };
  }

  return null;
}

function getRepairableSections(error: any) {
  const sections = error?.response?.data?.repairable_sections;

  if (!Array.isArray(sections)) {
    return [];
  }

  return sections.map((section: any) => ({
    sectionId: section?.section_id,
    pageId: section?.page_id,
    pageableId: section?.pageable_id,
    sectionType: section?.section_type,
    message: section?.message,
    currentContent: section?.current_content,
    repairEndpoints: {
      byPageId: section?.repair_endpoints?.by_page_id,
      byPageableId: section?.repair_endpoints?.by_pageable_id,
    },
  }));
}
function canRepairMissingSections(detail: string) {
  if (!detail) {
    return false;
  }

  const normalizedDetail = detail
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase();

  const hasMissingKeyword =
    normalizedDetail.includes("faltan") ||
    normalizedDetail.includes("missing");
  const hasSectionKeyword =
    normalizedDetail.includes("secciones") ||
    normalizedDetail.includes("sections");
  const hasRequiredKeyword =
    normalizedDetail.includes("requeridas") ||
    normalizedDetail.includes("required");

  return hasMissingKeyword && hasSectionKeyword && hasRequiredKeyword;
}

function getRepairPageId(error: any) {
  const pageId = error?.response?.data?.page_id ?? error?.response?.data?.page?.id;

  return typeof pageId === "number" ? pageId : null;
}

export default getPageStructureLoadError;